import * as constants from './constants';
import * as actions from './actions';
import * as actionTypes  from './actionTypes';
import reducer from './reducer';
import DossierFilesGrid from './components/DossierFilesGrid';


export default { 
    constants, reducer , actions, actionTypes, 
    DossierFilesGrid
}